<div class="modal-dialog modal-lg">
  <div class="modal-content">
    <div class="modal-header">
      <div class="col-sm-12">
        <h5 class="modal-title">Messages</h5>
      </div>
      <a (click)="close()" class="cstm-close">
        <span class="fas fa-times"></span>
      </a>
    </div>
    <div *ngIf="inquiry; else loading" class="modal-body">

      <div class="messages">
        <ng-container *ngIf="messages">

          <app-message-list
            [inquiry]="inquiry"
            [messages]="messages"
            [messageId]="messageId"
            [hasHeader]="true"
          ></app-message-list>

        </ng-container>
      </div>

      <div class="messages-sidebar">

        <div class="sidebar-holder container-box">

          <app-sidebar-expansion-panel *ngIf="inquiry" header="Occupied Dates">
            <app-occupied-dates [inquiry]="inquiry"></app-occupied-dates>
          </app-sidebar-expansion-panel>

          <app-sidebar-expansion-panel *ngIf="inquiry" header="Booking Details">
            <app-booking-details [inquiry]="inquiry"></app-booking-details>
          </app-sidebar-expansion-panel>

          <app-booking-charges [title]="'Quote Details'" [inquiry]="inquiry" [editable]="false"></app-booking-charges>

          <!--<app-sidebar-expansion-panel *ngIf="inquiry" header="Related Invoices">-->
          <!--<app-related-invoices [inquiry]="inquiry"></app-related-invoices>-->
          <!--</app-sidebar-expansion-panel>-->

        </div>
      </div>

    </div>

    <ng-template #loading>
      <div class="modal-body">
        <i class="fal fa-spinner fa-spin fa-5x loading-gif"></i>
      </div>
    </ng-template>
  </div>
</div>
